/*
  faq_section — disclosure list behavior for the shared .accordion component.
  Imported page-wise by sections/munchief-faq.liquid (defer); binds every
  instance on the page and re-inits on shopify:section:load.

  A row is open when its .accordion__item carries .is-open; the CSS animates
  the panel's max-height, so nothing here touches inline styles.
*/
(function () {
  function setOpen(item, open) {
    item.classList.toggle('is-open', open);
    var trigger = item.querySelector('.accordion__trigger');
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function initAccordion(accordion) {
    if (accordion.dataset.faqReady === 'true') return;
    accordion.dataset.faqReady = 'true';

    var single = accordion.dataset.faqSingle === 'true';
    var items = Array.prototype.slice.call(accordion.querySelectorAll('.accordion__item'));

    items.forEach(function (item) {
      var trigger = item.querySelector('.accordion__trigger');
      if (!trigger) return;

      setOpen(item, item.classList.contains('is-open'));

      trigger.addEventListener('click', function () {
        var willOpen = !item.classList.contains('is-open');
        if (single && willOpen) {
          items.forEach(function (other) {
            if (other !== item) setOpen(other, false);
          });
        }
        setOpen(item, willOpen);
      });
    });
  }

  /* Fixed list height ----------------------------------------------------
     Opt-in per section (data-faq-fixed): every panel reserves the height of
     the tallest answer, open or not, so the list is the same height in every
     state and opening a row swaps copy in place instead of pushing the page
     down.

     Height is reserved rather than animated: in this mode the stylesheet
     swaps the max-height reveal for an opacity one (see munchief-faq.css),
     and all this has to supply is the one number every panel is sized to.
     It is measured with the panels released to their natural height, so a
     long answer reserves what it actually needs.

     Only meaningful with "open one at a time" on — with several rows open at
     once the reserved row height is still one answer's worth. */
  function lockHeight(accordion) {
    if (accordion.dataset.faqFixed !== 'true') return;

    var panels = Array.prototype.slice.call(accordion.querySelectorAll('.accordion__panel'));
    if (!panels.length) return;

    accordion.classList.add('is-measuring');
    accordion.style.removeProperty('--faq-panel-height');

    var tallest = 0;
    panels.forEach(function (panel) {
      tallest = Math.max(tallest, panel.getBoundingClientRect().height);
    });

    accordion.classList.remove('is-measuring');
    accordion.style.setProperty('--faq-panel-height', Math.ceil(tallest) + 'px');
  }

  function lockAll(root) {
    (root || document).querySelectorAll('.accordion--page').forEach(lockHeight);
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('.accordion--page').forEach(initAccordion);
    lockAll(scope);
  }

  initAll();

  // Measured heights depend on how the copy wraps, so re-take them once the
  // webfont has swapped in and whenever the viewport changes width.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      lockAll();
    });
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      lockAll();
    }, 150);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
